import React, { useMemo } from 'react'

//* Components
import Text from 'components/common/Text'
import FancyButton from 'components/common/FancyButton'
import NewsItem from 'components/pages/NewsItem'

//* Style
import NewsSectionStyle from './style'
import { config } from 'helpers'

const NewsSection = ({ newsItems }) => {
	const storeNews = useMemo(() => newsItems.map((element, index) => <NewsItem itemData={element} key={index} />))

	return (
		<NewsSectionStyle>
			<Text tag='h3' className='orange terminaBold newsSectionTitle' text='news' />
			{storeNews}
			<FancyButton type='long' content='moreNews' isButtonChangePage={true} route={config.routes.news.path} />
		</NewsSectionStyle>
	)
}

export default NewsSection
